import { helpers } from './theme/helpers.js';
// import { sliders } from './theme/components/sliders.js';
import { headerMenu } from './theme/components/header-menu.js';
import { calendar } from './theme/components/calendar.js';

window.theme = {
	globals: {
		isTouch: typeof window !== 'undefined' && 'ontouchstart' in window,
	},

	init: function () {
		var self = this;

		// sliders.init();
		calendar.init();

		self.faq();

		var lightbox = new SimpleLightbox( '.block-gallery ul a' );
	},

	faq: function() {
		document.querySelectorAll('.faq-question').forEach(button => {
			button.addEventListener('click', () => {
				const item = button.parentElement;
				item.classList.toggle('active');
			});
		});
	},
};

jQuery(document).ready(function ($) {
	theme.init();
	headerMenu.init();
});